import React from 'react';
import { Marker } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import useStyles from './FindingCluster.styles';

const FindingCluster = ({ coordinates, pointCount }) => {
  const classes = useStyles({ pointCount });

  return (
    <Marker coordinates={coordinates} anchor="middle">
      <div className={classes.root}>
        <div className={classes.text}>{pointCount}</div>
      </div>
    </Marker>
  );
};

FindingCluster.propTypes = {
  coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
  pointCount: PropTypes.number.isRequired,
};

FindingCluster.defaultProps = {};

export default React.memo(FindingCluster);
